import { Group, Text } from "@mantine/core"
import {
  IconAlertTriangle,
  IconCheck,
  IconCircleOff,
} from "@tabler/icons-react"
import { CountryCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CountryInfo, MissingCountryCause } from "@tfg/types/endpoints/agec"

import { COUNTRIES } from "~/utils/countries"
import { useGetOperations } from "~/utils/operations.ts"

type Props = {
  activityName: string
  countryInfo: CountryInfo<MissingCountryCause>
}

function isCountryInfoMissing(countryInfo: CountryInfo<MissingCountryCause>) {
  return (
    countryInfo.cause &&
    (countryInfo.cause === "not-entered-yet" ||
      countryInfo.cause === "not-validated-yet")
  )
}

export const AGECCountryProperty = ({ activityName, countryInfo }: Props) => {
  const { t } = useTranslation("products")

  const operations = useGetOperations()
  const activityInfo = operations[activityName]

  if (!activityInfo) {
    return null
  }

  if (isCountryInfoMissing(countryInfo)) {
    return (
      <Group gap="xs">
        <IconAlertTriangle color="var(--mantine-color-error)" />
        <Text size="sm">
          {t("details.missing", { activity: activityInfo.name })}
        </Text>
      </Group>
    )
  } else {
    return (
      <Group gap="xs">
        {countryInfo.country ? (
          <IconCheck
            color={
              countryInfo.country
                ? "var(--mantine-color-success)"
                : "var(--mantine-color-info)"
            }
            size={16}
          />
        ) : (
          <IconCircleOff color="var(--mantine-color-info)" size={16} />
        )}
        <Text size="sm">
          {t("details.agec.activity", {
            activity: activityInfo.name,
          })}
        </Text>
        <Group>
          {countryInfo.country ? (
            <CountryCell
              size="sm"
              countryIso3166={countryInfo.country}
              countriesMapper={COUNTRIES}
            />
          ) : (
            <Text size="sm">{t("details.agec.na")}</Text>
          )}
        </Group>
      </Group>
    )
  }
}
